import React, { useEffect, useState } from "react";
import { useParams, Link, useOutletContext } from "react-router-dom"; // Import Link
import axios from "axios";
import $ from "jquery";
import AssetsView from "../../components/Modals/AssetsView";
import RaiseIssue from "../../components/Modals/RaiseIssue";
import AttendanceView from "./attendanceView";
import LeavesView from "./teamLeaveView";
import TravelView from "./teamTravelView";
import FeedbackView from "./addConfirmationFeed"

function Teamview() {
  const { id } = useParams(); // Get the employee ID from the URL
  console.log('id is ',id);
  const [uData, setEmployee] = useState(null);
  const getAssetImage = (type) => {
    switch (type?.toLowerCase()) {
      case "laptop":
        return "https://smarthr.dreamstechnologies.com/html/template/assets/img/products/product-05.jpg";
      case "mobile":
        return "https://i.postimg.cc/zGWv1n4R/iphone-11-PINE.jpg";
      case "phone":
        return "https://yourcdn.com/images/phone.png";
      default:
        return "https://yourcdn.com/images/default.png";
      case "desktop":
        return "https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.istockphoto.com%2Fphotos%2Fcomputer-tower&psig=AOvVaw15_m6dfIusRWd6b-Mzl7BE&ust=1752650617745000&source=images&cd=vfe&opi=89978449&ved=0CBIQjRxqFwoTCODIgciqvo4DFQAAAAAdAAAAABAE";
    }
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [assetId, setAssetId] = useState(null);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        setGlobalLoading?.(true);
        const response = await axios.get(
          `${API_BASE_URL}/employeeinfos/employeedetails/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("RESPONSE FROM BACKEND:", response.data);
        setEmployee(response.data); // Set the employee data
      } catch (error) {
        console.error("Error fetching employee details:", error);
      } finally {
        setGlobalLoading?.(false);
      }
    };

    fetchEmployeeDetails();
  }, [id, API_BASE_URL]);

  if (!uData) {
    console.log("Employee data is still loading...");
    return <p>Loading employee details for ID: {id}</p>;
  }
  const serialNos = uData.assets?.map((asset) => asset.serial_no) || [];

  const showmodal = (id) => {
    setAssetId(id);
    const modal = new window.bootstrap.Modal($("#asset_info"));
    modal.show();
  };
  const showRaiseIssueModal = (id) => {
    setAssetId(id); // sets the asset_id for the issue form
    const modal = new window.bootstrap.Modal($("#refuse_msg"));
    modal.show();
  };

  return (
    <div className="content">
      <div className="row align-items-center mb-4">
        <div className="col-sm-6">
          <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
            {/* <a href="companies-grid.html">
              <i className="ti ti-arrow-left me-2"></i>Companies
            </a>
            <span className="text-gray d-inline-flex ms-2">
              / BrightWave Innovations
            </span> */}
            <p>
              <Link
                to="/personalinfo/myteam"
                className="text-gray d-inline-flex ms-2"
              >
                ← Back to Team List
              </Link>
            </p>
          </h6>
        </div>
        <div className="col-sm-6">
          <div className="d-flex align-items-center justify-content-sm-end">
            {/* <a
              href="javascript:void(0);"
              className="btn btn-primary d-inline-flex align-items-center me-2"
              data-bs-toggle="modal"
              data-bs-target="#add_deals"
            >
              <i className="ti ti-circle-plus me-2"></i>Add Deal
            </a> */}
            {/* <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center"
            >
              <i className="ti ti-mail me-2"></i>Send Email
            </a> */}
            <div className="head-icons ms-2 mb-0">
              {/* <a
                href="javascript:void(0);"
                className=""
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-original-title="Collapse"
                id="collapse-header"
              >
                <i className="ti ti-chevrons-up"></i>
              </a> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-3 theiaStickySidebar">
          <div className="card card-bg-1">
            <div className="card-body p-0">
              <span
                className="avatar avatar-xl border bg-white rounded-circle m-auto d-flex mb-2"
                style={{
                  width: "100px", // ✅ Adjust size here
                  height: "100px", // ✅ Same height to keep it a circle
                  overflow: "hidden", // ✅ Crop overflow
                }}
              >
                <img
                  src={
                    uData.userpic
                      ? `https://pinepositivemoves.com/files/media/${uData.userpic}`
                      : "default-profile.png"
                  }
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // ✅ Ensures proper fit without distortion
                  }}
                />
              </span>
              <div className="text-center px-3 pb-3 border-bottom">
                <h5 className="d-flex align-items-center justify-content-center mb-1">
                  {uData.firstname} {uData.lastname}
                  <i
                    className={` ${
                      uData.status === "inactive"
                        ? "fa-solid fa-xmark ms-1 text-danger"
                        : "ti ti-discount-check-filled ms-1 text-success"
                    }`}
                  ></i>
                </h5>
                <p className="text-dark">
                  {uData.Designation} <br />
                  {uData.Department}
                </p>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6>Basic information</h6>
                  <a
                    href="javascript:void(0);"
                    className="btn btn-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_company"
                  >
                    {/* <i className="ti ti-edit"></i> */}
                  </a>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-id me-2"></i>
                    Emp_id
                  </span>
                  <p className="text-dark">{uData.id || "Not available"}</p>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-phone me-2"></i>
                    Phone
                  </span>
                  <p className="text-dark">{uData.Phone || "Not available"}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-mail-check me-2"></i>
                    Email
                  </span>

                  {/* <a href="javascript:void(0);" className="text-info d-inline-flex align-items-center">darlee@example.com <i className="ti ti-copy text-dark ms-2"></i></a> */}
                  <a href={`mailto:${uData.Email}`}>{uData.Email}</a>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-gender-male me-2"></i>
                    Joined On
                  </span>
                  <p className="text-dark">
                    {" "}
                    {uData.appointment_date || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-e-passport me-2"></i>
                    Reporting to
                  </span>
                  <div className="text-dark text-end">
                    {uData.reportingfirst_1 || uData.reportinglast_1 ? (
                      <p className="mb-0">
                        {uData.reportingfirst_1 || "Not available"}{" "}
                        {uData.reportinglast_1 || ""}
                      </p>
                    ) : (
                      <p className="mb-0">Not available</p>
                    )}
                    {uData.reportingfirst_2 || uData.reportinglast_2 ? (
                      <p className="mb-0">
                        {uData.reportingfirst_2 || "Not available"}{" "}
                        {uData.reportinglast_2 || ""}
                      </p>
                    ) : null}
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    PMoves Exp.
                  </span>
                  <p className="text-dark"> {uData.total_experience}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-9">
          <div className="row">
            <div className="card">
              <div className="card-body">
                <div className="contact-grids-tab p-0 mb-3">
                  <ul className="nav nav-underline" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="info-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#attendance"
                        type="button"
                        role="tab"
                        aria-selected="true"
                      >
                        Attendance
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="address-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#leaves"
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Leaves
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="address-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#travel"
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Travel
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="address-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#feedback"
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Feedback
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent3">
                  <div className="tab-pane fade show active" id="attendance" role="tabpanel" aria-labelledby="info-tab2" tabindex="0">
                    <AttendanceView viewUserId={id} />
                  </div>
                  <div className="tab-pane" id="leaves" role="tabpanel" aria-labelledby="info-tab2" tabindex="0">
                    <LeavesView viewUserId={id} />
                  </div>
                  <div className="tab-pane" id="travel" role="tabpanel" aria-labelledby="info-tab2" tabindex="0">
                    <TravelView viewUserId={id} />
                  </div>
                  <div className="tab-pane" id="feedback" role="tabpanel" aria-labelledby="info-tab2" tabindex="0">
                    <FeedbackView viewUserId={id} />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="assets"
                    role="tabpanel"
                    aria-labelledby="address-tab2"
                    tabindex="0"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Teamview;
